import React from "react";
import Skeleton from "react-loading-skeleton";
import styles from "../RestaurantList.module.css";
function RestaurantFloorsItemsSkeleton() {
  return (
    <>
      {Array.apply(0, Array(1)).map((n, i) => (
        <div key={i}>
          <h4 className={styles.floors_title}>
            <Skeleton
              count={1}
              style={{ marginLeft: "10px", lineHeight: 1.2 }}
              height={38}
              width={180}
            />
          </h4>
          <div className={styles.floors_wrapp_item}>
            {Array.apply(0, Array(16)).map((n, i) => (
              <div className={styles.item} key={i}  style={{ lineHeight: 1 }}>
                <Skeleton style={{ width: "100%" }} height={226} />
              </div>
            ))}
          </div>
        </div>
      ))}
    </>
  );
}
export default RestaurantFloorsItemsSkeleton;
